import React, { useState } from 'react';
import { MerchandiseBrowseCommon } from './../browse/MerchandiseBrowseCommon';
import { Header, Divider, Icon } from 'semantic-ui-react'

export function OrganisationMerchandise(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='tag' />
							Merchandise
						</Header>
					</Divider>
					<MerchandiseBrowseCommon slim={true} organisation={props.organisation}
						urlParams={false} relatedRendered={(val) => setChildRendering(val)}/>
				</>
			}
		</>
	);
}